import {ajaxRest, ajaxRestRoot} from './ajaxBase'

const CONTROLLER_PREFIX = 'sketchboard'

function getSketchboard (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}?${param}`,
      method: 'GET',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function getMenuList(param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/org/getCustomMenuList` + param,
      method: 'GET',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function setMenuList(orgId, treedata) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/org/setCustomMenuList`,
      method: 'POST',
      data: {
        org_id: orgId,
        id: orgId,
        treedata: treedata
      },
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function uploadLogo(orgId, name, content) {
  let fd = new FormData();
  fd.append('org_id', orgId);
  fd.append('path', 'assets/logo/' + name);
  fd.append('content', content);
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/upload`,
      method: 'POST',
      data: fd,
      timeout: {client: 10 * 1000}
    }
    ajaxRestRoot(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function getMenuOtherData(param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/org/getMenuOtherData` + param,
      method: 'GET',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function setMenuOtherData(orgId, other) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/org/setMenuOtherData`,
      method: 'POST',
      data: {
        org_id: orgId,
        id: orgId,
        other: other
      },
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}
export default { getSketchboard, getMenuList, setMenuList, uploadLogo, getMenuOtherData, setMenuOtherData }



// WEBPACK FOOTER //
// ./src/api/sketchboardAPI.js